export default __webpack_public_path__ + "static/pulse-credit-agreement-206e809d01aeabab02d4ccb487d2b3bb.pdf";